export const validateEircode = (eircode) => {
  if (!eircode || typeof eircode !== "string") {
    return { isValid: false, error: "Eircode is required" };
  }

  const stripped = eircode.replace(/\s+/g, "").toUpperCase();

  if (stripped.length === 0) {
    return { isValid: false, error: "Eircode is required" };
  }

  const standardPattern = /^[ACDEFHKNPRTVWXY][0-9]{2}[ACDEFHKNPRTVWXY0-9]{4}$/;
  const d6wPattern = /^D6W[ACDEFHKNPRTVWXY0-9]{4}$/;

  if (standardPattern.test(stripped) || d6wPattern.test(stripped)) {
    return { isValid: true, error: null };
  }

  return {
    isValid: false,
    error: "Please enter a valid Eircode. Examples: A12BC34, D6W1234",
  };
};

export const formatEircode = (eircode) => {
  if (!eircode || typeof eircode !== "string") return eircode;
  const stripped = eircode.replace(/\s+/g, "").toUpperCase();
  if (stripped.length === 7) {
    return `${stripped.slice(0, 3)} ${stripped.slice(3)}`;
  }
  return stripped;
};
